import { useCallback } from "react";
import { makeVar, ReactiveVar, useReactiveVar } from "@apollo/client";

export interface productsFiltersInputType {
  selectedCategoriesFilter?: string[];
}

const productsFiltersInitialValue: productsFiltersInputType = {
  selectedCategoriesFilter: [],
};

// The return value of makeVar is a function that you call to read or modify your reactive variable's value.
export const productsFiltersVar: ReactiveVar<productsFiltersInputType> =
  makeVar<productsFiltersInputType>(productsFiltersInitialValue);

export const clearProductsFilters = () => {
  productsFiltersVar(productsFiltersInitialValue);
};

export const useProductsFiltersValue = () => {
  const productsFiltersValue = useReactiveVar(productsFiltersVar);

  const updateProductsFilters = useCallback(
    (data: productsFiltersInputType) => {
      productsFiltersVar({
        ...productsFiltersValue,
        ...data,
      });
    },
    [productsFiltersValue]
  );

  return {
    productsFiltersValue,
    updateProductsFilters,
  };
};
